import {
  deleteProcurement,
  getContractProcurements,
  storeProcurement,
  updateProcurement
} from "../../api-helpers/contracts/api-procurements";

export default {
  state: {
    isGettingContractProcurements: false,
    contractProcurements: null,
    isStoringProcurement: false,
    isUpdatingProcurement: false,
    isDeletingProcurement: false
  },
  mutations: {
    setIsGettingContractProcurements(state, bool) {
      state.isGettingContractProcurements = bool;
    },
    setContractProcurements(state, procurements) {
      state.contractProcurements = procurements;
    },
    setIsStoringProcurement(state, bool) {
      state.isStoringProcurement = bool;
    },
    setIsUpdatingProcurement(state, bool) {
      state.isUpdatingProcurement = bool;
    },
    setIsDeletingProcurement(state, bool) {
      state.isDeletingProcurement = bool;
    }
  },
  actions: {
    async getContractProcurements({ state, commit }, contractId) {
      let contractProcurements = state.contractProcurements;
      if (!state.isGettingContractProcurements && contractId) {
        commit("setIsGettingContractProcurements", true);

        contractProcurements = await getContractProcurements(contractId);
        commit("setContractProcurements", contractProcurements);

        commit("setIsGettingContractProcurements", false);
      }
      return contractProcurements;
    },
    async storeProcurement({ state, commit, dispatch }, procurement) {
      let response;
      if (!state.isStoringProcurement) {
        commit("setIsStoringProcurement", true);

        response = await storeProcurement(procurement);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Procurement stored successfully.",
          errorText: "An error occurred while attempting to store Procurement.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            dispatch("getContractProcurements", procurement.contract_id);
          }
        });

        commit("setIsStoringProcurement", false);
      }
      return response;
    },
    async updateProcurement({ state, commit, dispatch }, procurement) {
      let response;
      if (!state.isUpdatingProcurement) {
        commit("setIsUpdatingProcurement", true);

        response = await updateProcurement(procurement);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Procurement updated successfully.",
          errorText:
            "An error occurred while attempting to update Procurement.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            if (procurement.dispatchAction) {
              dispatch(procurement.dispatchAction);
            } else {
              dispatch("getContractProcurements", procurement.contract_id);
            }
          }
        });

        commit("setIsUpdatingProcurement", false);
      }
      return response;
    },
    async deleteProcurement({ state, commit, dispatch }, procurement) {
      let response;
      if (!state.isDeletingProcurement) {
        commit("setIsDeletingProcurement", true);

        response = await deleteProcurement(procurement);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Procurement deleted successfully.",
          errorText:
            "An error occurred while attempthing to delete Procurement.",
          afterSuccessFunction: () => {
            commit("resetConfirmationModalParams");
            if (procurement.dispatchAction) {
              dispatch(procurement.dispatchAction);
            } else {
              dispatch("getContractProcurements", procurement.contract_id);
            }
          }
        });

        commit("setIsDeletingProcurement", false);
      }

      return response;
    }
  }
};
